import React from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col, ListGroupItem } from 'reactstrap'
import NewProperty from 'Components/Personal/Property/NewProperty'
import PropertyValueWithControl from 'Components/Personal/Property/PropertyValueWithControl'

const PropertyItem = ({ property }) => {
  const { t } = useTranslation();

  // Single property (name, nickname, etc)
  if (!property.multiple && (property.name !== 'howisaymyname')) {
    // Check if property has a value, including parameters for onmymind
    let hasValue = property.value !== undefined && property.value !== null && property.value !== ''

    // Special handling for onmymind - always treat as existing property
    if (property.name === 'onmymind') {
      console.log('PropertyItem onmymind - property:', property)
      console.log('PropertyItem onmymind - parameters:', property.parameters)
      hasValue = true // Always treat onmymind as existing property
      console.log('PropertyItem onmymind - hasValue set to true for onmymind')
    }

    // TEMPORARY FIX: Always show properties with values, even if they're empty strings
    // This ensures company and jobTitle are displayed
    if (property.name === 'company' || property.name === 'jobTitle') {
      hasValue = true
    }

    return (
      <ListGroupItem>
        {hasValue ? (
          <PropertyValueWithControl propertyMeta={property} value={{ value: property.value, objectId: property.objectId, verified: property.verified, parameters: property.parameters }} />
        ) : (
          <Row>
            <Col xs="12" md="3">{t(property.showName)}</Col>
            <Col xs="12" md="9"><NewProperty property={property} /></Col>
          </Row>
        )}
      </ListGroupItem>
    )
  }
  if (!property.multiple && (property.name === 'howisaymyname')) {
    // Non-multiple howisaymyname
    // Values located in .value
    if (property.value === undefined) {
      property.value = 'NONE'
    }
    // console.log('Non multiple HOWISAYMYNAME Value: ', property.value)
    // console.log('Non multiple HOWISAYMYNAME Name: ', property.name)
    return (

      <ListGroupItem>
        {property.value
          ? <PropertyValueWithControl propertyMeta={property} value={{ value: property.value, objectId: property.objectId, verified: property.verified, parameters: property.value }} />
          : (
            <Row>
              <Col xs="12" md="3">{property.showName}</Col>
              <Col xs="12" md="9"><NewProperty property={property} /></Col>
            </Row>
          )}
      </ListGroupItem>
    )
  }
  // console.log('Multiple Values: ', property.name, property.values)
  // Following handles multiple properties (Dates, emails, phone numbers, addresses, url addresses)
  // Values are located in parameters
  return (
    <>
      {property.values && Array.isArray(property.values) ? (
        property.values.map((value, index) => {
          // Ensure key is never empty string - handle null, undefined, empty string, or whitespace-only
          const objectIdStr = value.objectId != null ? String(value.objectId).trim() : ''
          const safeKey = objectIdStr !== '' ? objectIdStr : `value-${index}`
          return (
            <ListGroupItem key={safeKey}>
              <PropertyValueWithControl propertyMeta={property} value={value} />
            </ListGroupItem>
          )
        })
      ) : (
        // If no values exist, show the property itself
        <ListGroupItem>
          {property.value ? (
            <PropertyValueWithControl
              propertyMeta={property}
              value={{
                value: property.value,
                objectId: property.objectId,
                verified: property.verified,
                parameters: property.value
              }}
            />
          ) : (
            <Row>
              <Col xs="12" md="3">{t(property.showName)}</Col>
              <Col xs="12" md="9"><NewProperty property={property} /></Col>
            </Row>
          )}
        </ListGroupItem>
      )}
      <ListGroupItem>
        <NewProperty property={property} />
      </ListGroupItem>
    </>
  )
}

export default PropertyItem
